module.exports = __webpack_public_path__ + "img/object-mark5.eaa00959.png";